import ReactDOM from 'react-dom';
import './index.css';
import { bootstrapApplication } from './app';
import * as serviceWorker from './serviceWorker';

const locale = '' // navigator.language.split(/[-_]/)[0]; // language without region code

bootstrapApplication(locale).then((app) => {
  ReactDOM.render(app, document.getElementById('root'));
});

serviceWorker.register();
